export class PuestoEmvs {
    id?: number;
    solicitudes?: SolicitudPuesto[];
    tramite?: TramiteId;
    idDocumento1?: string;
    idDocumento2?: string;

    constructor(solicitudes?: SolicitudPuesto[], tramite?: TramiteId, id?: number, idDocumento1?:string, idDocumento2?:string) {
        this.solicitudes = solicitudes;
        this.tramite = tramite;
        this.id = id;
        this.idDocumento1 = idDocumento1
        this.idDocumento2 = idDocumento2
    }
}

export class SolicitudPuesto {
    convocatoria?: string;
    denominacion?: string;

    constructor(convocatoria?: string, denominacion?: string) {
        this.convocatoria = convocatoria;
        this.denominacion = denominacion;
    }
}

class TramiteId {
    id: string;
}
